/**
 * Workshop booking wizard helpers — single shared IIFE (pre-split lexical scope).
 * Boot stays in workshop-booking-wizard-flow.js + workshop-booking-wizard.js
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardHelpers) return;

  function normalizeTimeLabel(raw) {
    var t = String(raw || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ');
    if (!t) return '';
    var m = t.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/);
    if (!m) return t;
    var h = parseInt(m[1], 10);
    var hh = h < 10 ? '0' + h : String(h);
    return hh + ':' + m[2] + ' ' + m[3];
  }

  /** Workshop session length used for end-time display (2h 30m). */
  var WORKSHOP_DURATION_MINUTES = 150;

  function parseTimeLabelParts(raw) {
    var t = normalizeTimeLabel(raw);
    var m = String(t || '').match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!m) return null;
    return {
      hour12: parseInt(m[1], 10),
      minute: parseInt(m[2], 10),
      meridiem: m[3].toUpperCase(),
    };
  }

  function formatHourMinuteMeridiem(totalMinutes) {
    var day = ((totalMinutes % 1440) + 1440) % 1440;
    var hour24 = Math.floor(day / 60);
    var minute = day % 60;
    var meridiem = hour24 >= 12 ? 'PM' : 'AM';
    var hour12 = hour24 % 12;
    if (hour12 === 0) hour12 = 12;
    var hh = hour12 < 10 ? '0' + hour12 : String(hour12);
    var mm = minute < 10 ? '0' + minute : String(minute);
    return hh + ':' + mm + ' ' + meridiem;
  }

  function timePartsToMinutes(parts) {
    var hour24 = parts.hour12 % 12;
    if (parts.meridiem === 'PM') hour24 += 12;
    return hour24 * 60 + parts.minute;
  }

  function formatSessionTimeRange(rawStart) {
    var parts = parseTimeLabelParts(rawStart);
    if (!parts) {
      var fallback = normalizeTimeLabel(rawStart);
      return fallback || String(rawStart || '').trim();
    }
    var startLabel = formatHourMinuteMeridiem(timePartsToMinutes(parts));
    var endLabel = formatHourMinuteMeridiem(timePartsToMinutes(parts) + WORKSHOP_DURATION_MINUTES);
    return startLabel + ' - ' + endLabel;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function extractNumericEventIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function extractNumericVariantIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var varGid = /^gid:\/\/shopify\/ProductVariant\/(\d+)$/i.exec(s);
    if (varGid) return varGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function extractNumericVenueRefForUrl(val) {
    return extractNumericEventIdForUrl(val);
  }

  function extractEventIdFromUrl(url) {
    if (!url) return '';
    try {
      return extractNumericEventIdForUrl(new URL(String(url), window.location.origin).searchParams.get('event_id') || '');
    } catch (_) {
      return '';
    }
  }

  function extractPromoEventIdFromProduct(p) {
    if (!p || typeof p !== 'object') return '';
    return (
      extractNumericEventIdForUrl(
        p.event_id ||
          p.eventId ||
          p.id ||
          p.gid ||
          p.event_metaobject_gid ||
          p.eventMetaobjectGid ||
          p.metaobject_gid ||
          p.metaobjectGid ||
          p.workshop_event_id ||
          p.workshopEventId ||
          p.linked_event_id ||
          p.linkedEventId ||
          ''
      ) ||
      extractEventIdFromUrl(p.url) ||
      ''
    );
  }

  function refsOverlap(aKeys, bKeys) {
    if (!aKeys || !bKeys) return false;
    var seen = Object.create(null);
    for (var i = 0; i < aKeys.length; i++) {
      if (aKeys[i]) seen[aKeys[i]] = true;
    }
    for (var j = 0; j < bKeys.length; j++) {
      if (bKeys[j] && seen[bKeys[j]]) return true;
    }
    return false;
  }

  var Flow = window.WorkshopBookingWizardCalendar || window.WorkshopCityFlow;
  var LiveApi = window.WorkshopCityEvents;
  var WizardLive = window.WorkshopBookingWizardLive;

  var MONTHS = (Flow && Flow.MONTHS) || [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  var DOW_PICKER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DOW_MED = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var VARIANT_ROW_MIN_PX = 86;
  var VARIANT_ROW_MIN_H_PX = 54;
  var VARIANT_GRID_GAP_PX = 4;

  function getLiveApi() {
    return window.WorkshopCityEvents || LiveApi || null;
  }

  function getWizardLive() {
    return window.WorkshopBookingWizardLive || WizardLive || null;
  }

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = sid ? document.getElementById('WorkshopWizardData-' + sid) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  var WB_WORKSHOP_TYPES = ['mosaic', 'resin', 'ceramic', 'flower'];

  function vQtyKey(id) {
    return String(id == null ? '' : id).trim();
  }

  function splitFullName(full) {
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { first: '', last: '' };
    return { first: parts[0], last: parts.slice(1).join(' ') || parts[0] };
  }

  function formatMoney(cents) {
    if (Flow && typeof Flow.formatMoney === 'function') return Flow.formatMoney(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function slotBookable(slot) {
    var liveApi = getLiveApi();
    if (liveApi && typeof liveApi.isSlotBookable === 'function') return liveApi.isSlotBookable(slot);
    if (Flow && Flow.slotBookable) return Flow.slotBookable(slot);
    if (!slot || slotHidden(slot) || slotSoldOut(slot)) return false;
    return true;
  }

  function slotStatus(slot) {
    return String((slot && slot.status) || '')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }

  function slotDisplayStatus(slot) {
    return String((slot && slot.display_status) || '')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }

  function slotHidden(slot) {
    if (!slot) return true;
    var displayStatus = slotDisplayStatus(slot);
    if (displayStatus === 'hidden' || displayStatus === 'ended') return true;
    var st = slotStatus(slot);
    if (st === 'draft' || st === 'completed') return true;
    if (st === 'cancelled') {
      var cap = slot.capacity_remaining;
      if (cap == null || cap === '') {
        cap = slot._raw && slot._raw.capacity_remaining;
      }
      var capNum = cap != null && cap !== '' ? Number(cap) : null;
      return !(capNum != null && capNum > 0);
    }
    return false;
  }

  function slotSoldOut(slot) {
    if (!slot || slotHidden(slot)) return false;
    var liveApi = getLiveApi();
    if (liveApi && typeof liveApi.isSlotBookable === 'function') {
      return !liveApi.isSlotBookable(slot);
    }
    var st = slotStatus(slot);
    var displayStatus = slotDisplayStatus(slot);
    var cap = slot.capacity_remaining;
    if (cap == null || cap === '') {
      cap = slot._raw && slot._raw.capacity_remaining;
    }
    var capNum = cap != null && cap !== '' ? Number(cap) : null;
    if (
      (displayStatus === 'bookable' || displayStatus === 'active' || displayStatus === 'available') &&
      capNum != null &&
      capNum > 0
    ) {
      return false;
    }
    if (st === 'sold_out' || displayStatus === 'sold_out') return true;
    return capNum != null && capNum <= 0;
  }

  function slotVisible(slot) {
    return !!slot && !slotHidden(slot);
  }

  function formatSlotOptionText(slot) {
    if (!slot) return 'Session';
    var label = String(slot.time_label || '').trim();
    if (!label) {
      var dl = String(slot.display_label || '').trim();
      if (dl) {
        var pipe = dl.split('|');
        label = pipe.length > 1 ? pipe[pipe.length - 1].trim() : dl;
      }
    }
    if (!label) label = 'Session';
    else label = formatSessionTimeRange(label);
    if (slotSoldOut(slot)) return label + ' — Sold out';
    return label;
  }

  function slotDateKey(slot) {
    if (Flow && Flow.slotDateKey) return Flow.slotDateKey(slot);
    if (!slot) return '';
    if (slot.date_key) return String(slot.date_key).slice(0, 10);
    if (slot.schema_start) return String(slot.schema_start).slice(0, 10);
    return '';
  }

  function padDatePart(n) {
    n = Number(n);
    if (!Number.isFinite(n)) return '';
    return n < 10 ? '0' + n : String(n);
  }

  function toIsoDateKey(raw) {
    if (raw == null || raw === '') return '';
    if (raw instanceof Date && !isNaN(raw.getTime())) {
      return raw.getFullYear() + '-' + padDatePart(raw.getMonth() + 1) + '-' + padDatePart(raw.getDate());
    }
    var s = String(raw).trim();
    var iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (iso) return iso[1] + '-' + padDatePart(iso[2]) + '-' + padDatePart(iso[3]);
    var ymd = s.match(/^(\d{4})[/.](\d{1,2})[/.](\d{1,2})/);
    if (ymd) return ymd[1] + '-' + padDatePart(ymd[2]) + '-' + padDatePart(ymd[3]);
    var mdy = s.match(/^(\d{1,2})[/.](\d{1,2})[/.](\d{4})/);
    if (mdy) return mdy[3] + '-' + padDatePart(mdy[1]) + '-' + padDatePart(mdy[2]);
    return '';
  }

  function timeLabelFromDateTime(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/(?:T|\s)(\d{1,2}):(\d{2})(?::\d{2})?/);
    if (!m) return '';
    var h = parseInt(m[1], 10);
    var min = m[2];
    if (!Number.isFinite(h)) return '';
    var mer = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12;
    if (h12 === 0) h12 = 12;
    return (h12 < 10 ? '0' + h12 : String(h12)) + ':' + min + ' ' + mer;
  }

  function normalizeEventToSlot(ev) {
    if (!ev || typeof ev !== 'object') return null;
    var status = String(ev.status || ev.booking_status || ev.event_status || 'active')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
    if (status !== 'sold_out' && status !== 'cancelled' && status !== 'draft' && status !== 'completed') status = 'active';
    var displayStatus = String(ev.display_status || ev.displayStatus || status)
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');

    var gid = ev.event_metaobject_gid || ev.gid || ev.metaobject_gid || ev.id || ev.event_id || ev.canonical_event_id || '';

    var dateKey =
      toIsoDateKey(ev.date_key) ||
      toIsoDateKey(ev.schema_start) ||
      toIsoDateKey(ev.starts_at) ||
      toIsoDateKey(ev.event_date) ||
      toIsoDateKey(ev.start_date) ||
      toIsoDateKey(ev.date);

    var timeLabel = String(ev.time_label || '').trim();
    if (!timeLabel) {
      timeLabel =
        timeLabelFromDateTime(ev.schema_start) ||
        timeLabelFromDateTime(ev.starts_at) ||
        timeLabelFromDateTime(ev.start_time) ||
        '';
    }
    var displayLabel = String(ev.display_label || '').trim();
    if (!displayLabel) {
      displayLabel = dateKey || '';
      if (timeLabel) displayLabel = displayLabel ? displayLabel + ' | ' + timeLabel : timeLabel;
    }

    var capTot =
      ev.capacity_total != null && ev.capacity_total !== '' ? Number(ev.capacity_total) : null;
    if (!(capTot != null && Number.isFinite(capTot) && capTot > 0)) capTot = null;

    return {
      gid: gid != null && gid !== '' ? String(gid) : '',
      handle: String(ev.handle || ev.system_handle || ev.event_handle || ''),
      canonical_event_id:
        ev.canonical_event_id ||
        ev.event_id ||
        ev.event_metaobject_gid ||
        ev.id ||
        gid ||
        '',
      capacity_group_id: ev.capacity_group_id || ev.capacityGroupId || '',
      status: status,
      display_status: displayStatus,
      capacity_remaining: ev.capacity_remaining != null ? ev.capacity_remaining : ev.capacity,
      capacity_total: capTot,
      variant_id: ev.variant_id != null ? ev.variant_id : ev.variantId,
      schema_start: ev.schema_start || ev.starts_at || '',
      schema_end: ev.schema_end || ev.ends_at || '',
      date_key: dateKey,
      time_label: timeLabel,
      display_label: displayLabel,
      _raw: ev,
    };
  }

  function eventsToSlots(events) {
    var out = [];
    (events || []).forEach(function (ev) {
      var s = normalizeEventToSlot(ev);
      if (s && s.date_key) out.push(s);
    });
    return out;
  }

  function buildDaysMap(slots) {
    slots = (slots || []).filter(slotVisible);
    if (Flow && Flow.buildDaysMap) return Flow.buildDaysMap(slots, false);
    var map = {};
    slots.forEach(function (s) {
      var dk = slotDateKey(s);
      if (!dk) return;
      if (!map[dk]) map[dk] = { bookable: false, any: true };
      if (slotBookable(s)) map[dk].bookable = true;
    });
    return map;
  }

  function wizardViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function calendarDowLabels() {
    var w = wizardViewportWidth();
    if (w >= 750) return DOW_PICKER;
    /* Wednesday is the widest full name — use it only when a day cell can hold it. */
    if (w >= 430) return DOW_PICKER;
    return DOW_MED;
  }

  function calDateKey(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function formatCalDateBtn(key) {
    if (!key) return 'Select a date';
    var p = String(key).split('-').map(Number);
    if (p.length < 3 || !p[0]) return 'Select a date';
    var dt = new Date(p[0], p[1] - 1, p[2]);
    if (isNaN(dt.getTime())) return 'Select a date';
    var days = DOW_PICKER;
    var mon = MONTHS[p[1] - 1] || '';
    return days[dt.getDay()] + ', ' + mon + ' ' + p[2];
  }

  function formatBookingSubLabel(slot) {
    if (!slot) return '';
    var dk = slot.date_key || '';
    var tl = String(slot.time_label || '').trim();
    if (tl) tl = formatSessionTimeRange(tl);
    if (dk && tl) return dk + ' | ' + tl;
    return dk || tl || '';
  }

  /** Permanent store vs popup. Explicit venue_kind wins; then known store cities. */
  function isStoreVenue(venue) {
    if (!venue || typeof venue !== 'object') return false;
    var kind = String(venue.venue_kind || venue.kind || '').toLowerCase().trim();
    if (kind === 'store' || kind === 'permanent' || kind === 'shop') return true;
    if (kind === 'popup') return false;
    var parts = [
      venue.venue_name,
      venue.name,
      venue.city_name,
      venue.city,
      venue.venue_handle,
      venue.handle,
      venue.city_key,
    ];
    for (var i = 0; i < parts.length; i++) {
      var s = String(parts[i] || '')
        .trim()
        .toLowerCase();
      if (!s) continue;
      if (s === 'dallas' || s === 'carrollton' || s === 'orlando') return true;
      /* city_key: us-tx-dallas / us-fl-orlando; names: "Orlando, FL" */
      if (/(^|-)(dallas|carrollton|orlando)$/.test(s)) return true;
      if (/\b(dallas|carrollton|orlando)\b/.test(s)) return true;
    }
    return false;
  }

  function formatPopupDateLabel(dateKey) {
    var full = formatCalDateBtn(dateKey);
    return full === 'Select a date' ? String(dateKey || '').slice(0, 10) : full;
  }

  function workshopTypeFromText(text) {
    var raw = String(text || '')
      .toLowerCase()
      .trim();
    if (!raw) return '';
    for (var i = 0; i < WB_WORKSHOP_TYPES.length; i++) {
      var t = WB_WORKSHOP_TYPES[i];
      if (raw === t || raw.indexOf(t) !== -1) return t;
    }
    return '';
  }

  function fetchWorkshopTypeFromProduct(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve('');
    if (!window.__WB_WORKSHOP_TYPE_BY_HANDLE) window.__WB_WORKSHOP_TYPE_BY_HANDLE = Object.create(null);
    if (window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] != null) {
      return Promise.resolve(window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        var tags = [];
        if (product && product.tags) {
          if (Array.isArray(product.tags)) tags = product.tags;
          else {
            tags = String(product.tags)
              .split(',')
              .map(function (t) {
                return String(t).trim();
              })
              .filter(Boolean);
          }
        }
        var found = '';
        for (var ti = 0; ti < tags.length; ti++) {
          found = workshopTypeFromText(tags[ti]);
          if (found) break;
        }
        if (!found) found = workshopTypeFromText(product && product.handle);
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = found;
        return found;
      })
      .catch(function () {
        window.__WB_WORKSHOP_TYPE_BY_HANDLE[handle] = '';
        return '';
      });
  }

  function resolveWaitlistWorkshopType(wizardRoot, bookingRoot, data) {
    var fromBooking = bookingRoot ? workshopTypeFromText(bookingRoot.getAttribute('data-workshop-type')) : '';
    if (fromBooking) return Promise.resolve(fromBooking);
    var fromWizard = wizardRoot ? workshopTypeFromText(wizardRoot.getAttribute('data-workshop-type')) : '';
    if (fromWizard) return Promise.resolve(fromWizard);
    if (data && data.workshopType) {
      var fromData = workshopTypeFromText(data.workshopType);
      if (fromData) return Promise.resolve(fromData);
    }
    var handle = '';
    if (data && data.productHandle) handle = String(data.productHandle).trim();
    if (!handle && wizardRoot) handle = String(wizardRoot.getAttribute('data-product-handle') || '').trim();
    if (!handle && bookingRoot) handle = String(bookingRoot.getAttribute('data-product-handle') || '').trim();
    var fromHandle = workshopTypeFromText(handle);
    if (fromHandle) return Promise.resolve(fromHandle);
    return fetchWorkshopTypeFromProduct(handle);
  }


  var bag = {
    WBWUtils: {
      normalizeTimeLabel: normalizeTimeLabel,
      parseTimeLabelParts: parseTimeLabelParts,
      formatHourMinuteMeridiem: formatHourMinuteMeridiem,
      timePartsToMinutes: timePartsToMinutes,
      formatSessionTimeRange: formatSessionTimeRange,
      escapeHtml: escapeHtml,
      extractNumericEventIdForUrl: extractNumericEventIdForUrl,
      extractNumericVariantIdForUrl: extractNumericVariantIdForUrl,
      extractNumericVenueRefForUrl: extractNumericVenueRefForUrl,
      extractEventIdFromUrl: extractEventIdFromUrl,
      extractPromoEventIdFromProduct: extractPromoEventIdFromProduct,
      refsOverlap: refsOverlap
    },
    Flow: Flow,
    LiveApi: LiveApi,
    WizardLive: WizardLive,
    MONTHS: MONTHS,
    DOW_PICKER: DOW_PICKER,
    DOW_MED: DOW_MED,
    DOW_SHORT: DOW_SHORT,
    VARIANT_ROW_MIN_PX: VARIANT_ROW_MIN_PX,
    VARIANT_ROW_MIN_H_PX: VARIANT_ROW_MIN_H_PX,
    VARIANT_GRID_GAP_PX: VARIANT_GRID_GAP_PX,
    WB_WORKSHOP_TYPES: WB_WORKSHOP_TYPES,
    buildDaysMap: buildDaysMap,
    calDateKey: calDateKey,
    calendarDowLabels: calendarDowLabels,
    escapeHtml: escapeHtml,
    eventsToSlots: eventsToSlots,
    extractEventIdFromUrl: extractEventIdFromUrl,
    extractNumericEventIdForUrl: extractNumericEventIdForUrl,
    extractNumericVariantIdForUrl: extractNumericVariantIdForUrl,
    extractNumericVenueRefForUrl: extractNumericVenueRefForUrl,
    extractPromoEventIdFromProduct: extractPromoEventIdFromProduct,
    fetchWorkshopTypeFromProduct: fetchWorkshopTypeFromProduct,
    formatBookingSubLabel: formatBookingSubLabel,
    formatCalDateBtn: formatCalDateBtn,
    formatHourMinuteMeridiem: formatHourMinuteMeridiem,
    formatMoney: formatMoney,
    formatPopupDateLabel: formatPopupDateLabel,
    formatSessionTimeRange: formatSessionTimeRange,
    formatSlotOptionText: formatSlotOptionText,
    getLiveApi: getLiveApi,
    getWizardLive: getWizardLive,
    isStoreVenue: isStoreVenue,
    normalizeEventToSlot: normalizeEventToSlot,
    normalizeTimeLabel: normalizeTimeLabel,
    padDatePart: padDatePart,
    parseData: parseData,
    parseTimeLabelParts: parseTimeLabelParts,
    refsOverlap: refsOverlap,
    resolveWaitlistWorkshopType: resolveWaitlistWorkshopType,
    slotBookable: slotBookable,
    slotDateKey: slotDateKey,
    slotDisplayStatus: slotDisplayStatus,
    slotHidden: slotHidden,
    slotSoldOut: slotSoldOut,
    slotStatus: slotStatus,
    slotVisible: slotVisible,
    splitFullName: splitFullName,
    timeLabelFromDateTime: timeLabelFromDateTime,
    timePartsToMinutes: timePartsToMinutes,
    toIsoDateKey: toIsoDateKey,
    vQtyKey: vQtyKey,
    wizardViewportWidth: wizardViewportWidth,
    workshopTypeFromText: workshopTypeFromText
  };
  global.WorkshopBookingWizardHelpers = bag;
  global.WorkshopBookingWizardUtils = bag.WBWUtils;
  global.WorkshopBookingWizardCore = bag;
  global.WorkshopBookingWizardSlots = bag;
  global.WorkshopBookingWizardPromo = bag;
  global.WorkshopBookingWizardUrl = bag;
  global.WorkshopBookingWizardVariants = bag;
  global.WorkshopBookingWizardLayout = bag;
})(typeof window !== "undefined" ? window : this);
